import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eef34412"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mypage py-3" }
const _hoisted_3 = { class: "section1" }
const _hoisted_4 = {
  key: 0,
  class: "px-3"
}
const _hoisted_5 = { class: "menu-content pt-4 mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-blue text-size-14"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "text-size-14"
}
const _hoisted_9 = {
  key: 1,
  class: "text-size-14"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red" }, "未登録", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "text-mild text-size-14 ml-1" }
const _hoisted_13 = {
  key: 0,
  class: "text-blue text-size-14 ml-1"
}
const _hoisted_14 = { class: "text-blue text-size-14 ml-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "ポイント", -1))
const _hoisted_16 = { class: "text-blue text-size-14" }
const _hoisted_17 = {
  key: 0,
  class: "section5 px-3"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500" }, "\n            開発メニュー(prod, demoでは表示されません)\n          ", -1))
const _hoisted_19 = { class: "bg-white border border-outline-color px-3 mt-1 round-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "LocalStorageクリア", -1))
const _hoisted_21 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_22 = { class: "bg-white border border-outline-color px-3 mt-1 round-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "「カイテク（介護・看護）」アプリに変更", -1))
const _hoisted_24 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_25 = { class: "bg-white border border-outline-color px-3 mt-1 round-4" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "「カイテク薬剤師」アプリに変更", -1))
const _hoisted_27 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_28 = { class: "px-3 mt-2" }
const _hoisted_29 = { class: "text-mild text-size-10" }
const _hoisted_30 = { class: "text-mild text-size-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileCard = _resolveComponent("ProfileCard")!
  const _component_VerificationAccountStep = _resolveComponent("VerificationAccountStep")!
  const _component_Ad = _resolveComponent("Ad")!
  const _component_MenuRouterLinkItem = _resolveComponent("MenuRouterLinkItem")!
  const _component_TooltipHighlightText = _resolveComponent("TooltipHighlightText")!
  const _component_TooltipPopup = _resolveComponent("TooltipPopup")!
  const _component_RankIcon14 = _resolveComponent("RankIcon14")!
  const _component_MenuLinkGroup = _resolveComponent("MenuLinkGroup")!
  const _component_VerifiedStatusLabel = _resolveComponent("VerifiedStatusLabel")!
  const _component_MenuAnchorLinkItem = _resolveComponent("MenuAnchorLinkItem")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_ctx.user && !_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.user.hasRegisteredProfile)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['bg', `bg-${_ctx.product.slug}`])
            }, null, 2))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.canApplyOrHasWorked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.avgEvaluation && _ctx.balance && _ctx.myApplicationCount)
                    ? (_openBlock(), _createBlock(_component_ProfileCard, {
                        key: 0,
                        user: _ctx.user,
                        currentRankLabel: _ctx.currentRankLabel,
                        avgEvaluation: _ctx.avgEvaluation,
                        balance: _ctx.balance,
                        myApplicationCount: _ctx.myApplicationCount,
                        cancelPercentage: _ctx.cancelPercentage,
                        suddenCancelPercentage: _ctx.suddenCancelPercentage
                      }, null, 8, ["user", "currentRankLabel", "avgEvaluation", "balance", "myApplicationCount", "cancelPercentage", "suddenCancelPercentage"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_component_VerificationAccountStep, {
                  key: 1,
                  isLoading: _ctx.isLoading,
                  user: _ctx.user,
                  hasBankAccount: _ctx.hasBankAccount
                }, null, 8, ["isLoading", "user", "hasBankAccount"]))
          ]),
          _createTextVNode(),
          _createVNode(_component_Ad, {
            adSlot: "mypage",
            class: "ad-slot-mypage"
          }),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_MenuLinkGroup, {
              label: "勤務管理",
              class: "section2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MenuRouterLinkItem, {
                  id: "tooltippopup-to-menu-router-link-item-salary",
                  label: "給与管理",
                  to: { name: 'Salary' }
                }, {
                  right: _withCtx(() => [
                    (_ctx.balance)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.currency(_ctx.balance.amount)) + "円\n              ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_TooltipPopup, {
                  position: "top",
                  targetSelector: "#tooltippopup-to-menu-router-link-item-salary"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createTextVNode("\n              お仕事が完了後、"),
                      _createVNode(_component_TooltipHighlightText, null, {
                        default: _withCtx(() => [
                          _createTextVNode("いつでも給与引出可能")
                        ], undefined, true),
                        _: 1
                      }),
                      _createTextVNode("！"),
                      _hoisted_7,
                      _createTextVNode("\n              引き出し手数料も"),
                      _createVNode(_component_TooltipHighlightText, null, {
                        default: _withCtx(() => [
                          _createTextVNode("無料")
                        ], undefined, true),
                        _: 1
                      }),
                      _createTextVNode("！\n            ")
                    ])
                  ], undefined, true),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_MenuRouterLinkItem, {
                  label: "働きたい日",
                  to: { name: 'DesiredWorkSchedules' }
                }, {
                  right: _withCtx(() => [
                    (_ctx.hasDesiredWorkSchedules)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                          _createElementVNode("span", {
                            class: _normalizeClass([
                    _ctx.hasDesiredWorkSchedulesThisMonth ? 'text-blue' : 'text-red',
                    'mr-1'
                  ])
                          }, _toDisplayString(_ctx.desiredWorkSchedulesThisMonthLabel), 3),
                          _createTextVNode(),
                          _createElementVNode("span", {
                            class: _normalizeClass(
                    _ctx.hasDesiredWorkSchedulesFromNextMonth
                      ? 'text-blue'
                      : 'text-red'
                  )
                          }, _toDisplayString(_ctx.desiredWorkSchedulesFromNextMonthLabel), 3)
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_9, _hoisted_11))
                  ]),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_MenuRouterLinkItem, {
                  label: "今月のランク",
                  to: { name: 'Rank' }
                }, {
                  right: _withCtx(() => [
                    _createVNode(_component_RankIcon14, {
                      rank: _ctx.user.rank
                    }, null, 8, ["rank"]),
                    _createTextVNode(),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.currentRankLabel), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_MenuRouterLinkItem, {
                  label: "勤務評価",
                  to: { name: 'MyReview' }
                }, {
                  right: _withCtx(() => [
                    (_ctx.avgEvaluation)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.evaluationRound(_ctx.avgEvaluation.totalAverage)) + "点 (" + _toDisplayString(_ctx.avgEvaluation.count || 0) + "件)\n              ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_MenuRouterLinkItem, {
                  label: "信用スコア",
                  to: { name: 'OrdersCancelPolicyDisplay' }
                }, {
                  right: _withCtx(() => [
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.user.creditScore) + "pt\n              ", 1)
                  ]),
                  _: 1
                })
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_MenuLinkGroup, {
              label: "ポイント・キャンペーン",
              class: "section3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MenuRouterLinkItem, { to: { name: 'MyPoint' } }, {
                  left: _withCtx(() => [
                    _hoisted_15
                  ]),
                  right: _withCtx(() => [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.currency(_ctx.user.caisukePoint)) + "pt\n              ", 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_MenuRouterLinkItem, {
                  label: "招待キャンペーン",
                  to: { name: 'ReferPromotion' }
                })
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_MenuLinkGroup, { label: "アカウント" }, {
              default: _withCtx(() => [
                _createVNode(_component_MenuRouterLinkItem, {
                  label: "認証",
                  to: { name: 'MypageAccount' }
                }, {
                  right: _withCtx(() => [
                    (_ctx.hasNotice)
                      ? (_openBlock(), _createBlock(_component_VerifiedStatusLabel, {
                          key: 0,
                          text: _ctx.userVerifiedStatusLabel,
                          type: _ctx.userVerifiedStatusLabelType
                        }, null, 8, ["text", "type"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createTextVNode(),
                _createVNode(_component_MenuRouterLinkItem, {
                  label: "設定",
                  to: { name: 'AccountInfo' }
                })
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_MenuLinkGroup, { label: "教育" }, {
              default: _withCtx(() => [
                _createVNode(_component_MenuRouterLinkItem, {
                  label: "研修",
                  to: { name: 'Training' }
                })
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_MenuLinkGroup, { label: "サポート" }, {
              default: _withCtx(() => [
                _createVNode(_component_MenuAnchorLinkItem, {
                  label: "FAQ・お問い合わせ",
                  href: _ctx.externalLink.faq
                }, null, 8, ["href"]),
                _createTextVNode(),
                _createVNode(_component_MenuAnchorLinkItem, {
                  label: "転職の報告",
                  href: _ctx.externalLink.reportJobChange
                }, null, 8, ["href"]),
                _createTextVNode(),
                _createVNode(_component_MenuAnchorLinkItem, {
                  label: "ご意見・ご要望",
                  href: _ctx.externalLink.anonymousFeedbackForm
                }, null, 8, ["href"])
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            (_ctx.isDevMenuVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", {
                      role: "button",
                      class: "d-flex justify-content-between align-items-center border-outline-color py-3",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearLocalStorage && _ctx.clearLocalStorage(...args)))
                    }, [
                      _hoisted_20,
                      _createTextVNode(),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_FeatherIcon, {
                          icon: "chevron-right",
                          size: "1x",
                          class: "text-gray-05 ml-2"
                        })
                      ])
                    ])
                  ]),
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", {
                      role: "button",
                      class: "d-flex justify-content-between align-items-center border-outline-color py-3",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeProduct('caitech_care')))
                    }, [
                      _hoisted_23,
                      _createTextVNode(),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_FeatherIcon, {
                          icon: "chevron-right",
                          size: "1x",
                          class: "text-gray-05 ml-2"
                        })
                      ])
                    ])
                  ]),
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", {
                      role: "button",
                      class: "d-flex justify-content-between align-items-center border-outline-color py-3",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeProduct('caitech_pharmacist')))
                    }, [
                      _hoisted_26,
                      _createTextVNode(),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_FeatherIcon, {
                          icon: "chevron-right",
                          size: "1x",
                          class: "text-gray-05 ml-2"
                        })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("p", _hoisted_29, "Version No: " + _toDisplayString(_ctx.versionNo), 1),
            _createTextVNode(),
            _createElementVNode("p", _hoisted_30, "Build Version: " + _toDisplayString(_ctx.buildVersion), 1)
          ])
        ]),
        _createTextVNode(),
        _createVNode(_component_AppFooter),
        _createTextVNode(),
        _createVNode(_component_BlockBack)
      ]))
    : _createCommentVNode("", true)
}